export enum PreviewTypeEnum {
  Table = 1,
  DragDrop = 2,
}
